module.exports = __webpack_public_path__ + "static/media/totem4.d58e02e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Totem/totem4.jpg
// module id = 362
// module chunks = 0